import { render, staticRenderFns } from "./OrderOperation.vue?vue&type=template&id=36473f68&"
import script from "./OrderOperation.vue?vue&type=script&lang=js&"
export * from "./OrderOperation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports